<div>
  <app-header></app-header>
  <router-outlet></router-outlet>
  <div class="container mb-5">
    <div class="row">
        <div class="col-xs-6 col-md-8 text-center">©2020 Ryan Handby.</div>
        <div class="col-xs-6 col-md-4 text-center" (click)="backToTop()">Back to top <fa-icon [icon]="faArrowCircleUp" [styles]="{'color': '#fff'}"></fa-icon></div>
    </div>
  </div>
</div>